import { HttpErrorResponse } from '@angular/common/http';

export interface ErrorModel {
  status?: number;
  error?: ErrorModel;
  code?: string;
  message?: string;
  details?: { message: string }[];
}

export function getErrorMessage(error: HttpErrorResponse | ErrorModel): string {
  if (error.status != null) {
    return ErrorMessageMap.get(String(error.status)) || `Error ${error.status.toString()}`;
  }
  return 'An unexpected error occurred';
}

const ErrorMessageMap: Map<string, string> = new Map<string, string>();
ErrorMessageMap.set('0', "Server can't be reached");
ErrorMessageMap.set('400', '400 Bad Request');
ErrorMessageMap.set('401', '401 Unauthorized');
ErrorMessageMap.set('403', '403 Forbidden');
ErrorMessageMap.set('404', '404 Not Found');
ErrorMessageMap.set('408', '408 Request Timeout');
ErrorMessageMap.set('409', '409 Conflict');
ErrorMessageMap.set('500', '500 Internal Server Error');
